// @ts-nocheck
// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';
import { imgae200 } from './userImage';

// ----------------------------------------------------------------------

export default function MyAvatar({ user: userData, ...other }) {
  const { user: currentUser } = useAuth();

  const data = userData || currentUser;
  // Prefer a uploaded picture; otherwise fall back to a coloured initial
  // (same pattern used everywhere else — TeamRow.tsx, InviteNewUser.tsx).
  // No mock-image fallback, which made every avatar identical.
  const hasPicture = !!data?.picture;
  const displayName =
    (data?.first_name || data?.last_name)
      ? `${data?.first_name || ''} ${data?.last_name || ''}`.trim()
      : (data?.displayName || data?.email || '?');
  const a = createAvatar(displayName);

  return (
    <MAvatar
      src={hasPicture ? imgae200(data.picture) : undefined}
      alt={displayName}
      color={hasPicture ? 'default' : a.color}
      {...other}
    >
      {a.name}
    </MAvatar>
  );
}